export enum UISizes {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
}